// The second line in this file should always be the build date. For the scripts to work.
export const BUILD_DATE = "20210601";
export const MAIN_APP_VERSION = "v4.1";

export const WEATHER_FIRST_YEAR = "2010";
export const SEASON_FIRST_DATE = "-03-01";
export const SEASON_LAST_DATE = "-06-30";

export const APP_BETA_OPEN = false;